const previewFileTypes = {
  IMAGE: 'image',
  VIDEO: 'video',
  AUDIO: 'audio',
};

export default previewFileTypes;
